import {
    cleanCommonParams,
    cleanTimestampsParams,
    mapAttachmentParams,
    mapFeedItemParams,
    mapPlatformsParams,
    mapProductsParams,
    mapStatesParams,
    mapTagsParams,
} from './common';

const mapGuideResourceParams = (isCreate, resource) => {
    if (!resource) {
        return {
            resource_attributes: {},
        };
    }

    const { id, writing_companies, ...params } = resource;
    const resourceAttributes = cleanTimestampsParams(params);

    if (writing_companies !== undefined) {
        resourceAttributes.writing_company_ids = writing_companies;
    }

    return {
        resource_attributes: resourceAttributes,
    };
};

const mapGuideParams = (
    isCreate,
    {
        attachment,
        tags,
        feed_item,
        platforms,
        products,
        resource,
        resource_id,
        search_phrase_ids,
        states,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            guide: {
                ...cleanCommonParams(params),
                ...mapAttachmentParams(isCreate, attachment),
                ...mapFeedItemParams(isCreate, feed_item),
                ...mapPlatformsParams(isCreate, platforms),
                ...mapProductsParams(isCreate, products),
                ...mapGuideResourceParams(isCreate, resource),
                ...mapStatesParams(isCreate, states),
                ...mapTagsParams(isCreate, tags),
                search_phrase_ids: search_phrase_ids || [],
            },
        });
    });
};

export { mapGuideParams };
